

























import { Vue, Component, Prop } from 'vue-property-decorator';
import clounbtn from '../components/Cloundbtn.vue';
import VoteButton from '../components/VoteButtonNew.vue';
import { Icon } from 'vant';

Vue.use(Icon);

@Component({
  components: {
    clounbtn,
    VoteButton,
  },
})
export default class ListItem extends Vue {
  @Prop() canVote: boolean = true;
  @Prop() canshow: boolean = false;
  @Prop() data!: any;
  @Prop({ default: false }) showZanBtn!: boolean;
  @Prop() index!: number;
  voteName: string = '2023project/q2/2023byd_drbs';
  thurl: any = require('../assets/search/btnvote.png');
  ispress: boolean = false;
  cover = this.data.cover.split('|');
  mounted() {
    console.log('cnavote:', this.canVote);
  }
  subvote() {
    if (this.ispress) {
      return false;
    }
    this.ispress = true;
    setTimeout(() => {
      window.location.reload();
      this.ispress = false;
    }, 500);
  }
  navToDetail(inway: any, userId: any) {
    this.$router.push('tovoteDetail?inway=' + inway + '&userId=' + userId);
  }
  votSuccess(e: any) {
    this.data.votes = e;
  }
}
